















































































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
// import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

import { upload } from '../../common/util/ossUploadService';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import AddressSelect from '@/components/AddressSelect.vue';
import { formRules } from '@/common/util/validator';
import { enums } from '@/common/enums';
import { yun, CspInquiry } from '@/http';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        // ElImageViewer,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        AddressSelect,
        SearchPanel,
        DraggerImg,
    },
})
export default class carrierManager extends Vue {
    public stateType = enums.stateType;
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public dialogVisible = false;
    public dialogVisibles = false;
    public dialogVisible1 = false;
    public handleClose() {
        this.fileList = [];
        this.timeList1 = [];
        this.dialogVisible = false;
    }
    public handleClose1() {
        this.fileList = [];
        this.timeList1 = [];
        this.dialogVisible1 = false;
    }

    public handleCloses() {
        this.fileList = [];
        this.timeList1 = [];
        this.dialogVisibles = false;
    }

    public searchValue: any = {
        code: '',
        carrierName: '',
        inquiryCode: '',
        signStartTime: '',
        signEndTime: '',
        orderBy: '',
        asc: true,
    };
    //根据权限判断按钮显隐

    public hts3: boolean = false;

    public dbbl3: boolean = false;
    public created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        this.dbbl3 = webMenus.includes('dbbl3');
        this.hts3 = webMenus.includes('hts3');
    }
    public timeList = [];
    public datetimerange(value) {
        if (value) {
            this.searchValue.signStartTime = value[0];
            this.searchValue.signEndTime = value[1];
        } else {
            this.searchValue.signStartTime = '';
            this.searchValue.signEndTime = '';
        }
    }
    public timeList1 = [];
    public datetimerange1(value) {
        if (value) {
            this.formData.validityStartTime = value[0];
            this.formData.validityEndTime = value[1];
        } else {
            this.formData.validityStartTime = '';
            this.formData.validityEndTime = '';
        }
    }
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('contractManage', JSON.stringify(this.colData));
    }
    public colData = JSON.parse(localStorage.getItem('contractManage'))
        ? JSON.parse(localStorage.getItem('contractManage'))
        : [
              { title: '车牌号', isShow: true, disabled: false },
              { title: '车长', isShow: true, disabled: false },
              { title: '车型', isShow: true, disabled: false },
              { title: '核定载重（吨）', isShow: true, disabled: false },
              { title: '总质量（吨）', isShow: true, disabled: false },
              { title: '状态', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
              { title: '承运商', isShow: true, disabled: false },
              { title: '发货企业', isShow: true, disabled: false },
          ];

    public labelPosition: string = 'right';

    public $refs!: {
        pagination: HTMLFormElement;
        pagination1: HTMLFormElement;
        multipleTable: HTMLFormElement;
        formData: HTMLFormElement;
        address: HTMLFormElement;
    };

    public searchFunc() {
        sessionStorage.setItem('contractManage_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
    public searchFunc1() {
        this.$refs.pagination1.handleCurrentChange(1);
        this.searchPagin1.skip = 0;
    }
    public resetSearchValue() {
        this.searchValue = {
            enabled: '',
            carCode: '',
            searchValue: '',
            carrierName: '',
            carLength: '',
            orderBy: '',
            asc: true,
        };
        this.carLengths = [];
        this.timeList = [];
        this.searchFunc();
    }
    public resetSearchValue1() {
        this.carName = '';
        this.loadData1();
    }
    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public rePagin1 = false;
    public tabelData = [];
    public total = 20;
    public isActive: boolean = false;

    public tableData: any = [];

    public async loadData() {
        this.loading = true;
        try {
            let res = await yun.ContractGetList({
                ...this.searchValue,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.$refs.pagination.setNowPage(this.searchPagin.count);
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
        } catch {
            this.loading = false;
        }
    }
    public total1: any = 0;
    public tableData1: any = [];
    public async onPaginationChange1(pagin: Pagination) {
        this.searchPagin1 = pagin;
        this.loadData1();
    }
    public searchPagin1: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async loadData1() {
        this.tableData1 = [];
        let res = await yun.GetBindCarList({
            carId: this.selectDirver.id,
            driverName: this.carName,
            skip: this.searchPagin1.skip,
            count: this.searchPagin1.count,
        });
        this.tableData1 = res.data;
        console.log('res', res);
        let skip = this.searchPagin.skip;
        this.$refs.pagination1.setPage(this.searchPagin1.currentPage);
        this.tableData1.map((item, index) => {
            item.index = skip++ + 1;
        });
        this.total1 = res.total;
    }
    public carLengthList: any = [];
    public vehicleTypeList: any = [];
    public async getdd() {
        this.carLengthList = await yun.GetDicList({ typeName: 'carLength' });
        this.vehicleTypeList = await yun.GetDicList({ typeName: 'vehicleType' });
    }
    public mounted() {
        this.getdd();
        if (sessionStorage.getItem('contractManage_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('contractManage_searchValue'));
            this.searchPagin = sessionStorage.getItem('contractManage_page')
                ? JSON.parse(sessionStorage.getItem('contractManage_page'))
                : this.searchPagin;
            if (this.searchValue.signStartTime && this.searchValue.signEndTime) {
                this.timeList = [this.searchValue.signStartTime, this.searchValue.signEndTime];
            }
            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('contractManage_page')
                ? JSON.parse(sessionStorage.getItem('contractManage_page'))
                : this.searchPagin;

            this.loadData();
        }
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('contractManage_page', JSON.stringify(pagin));
        this.loadData();
    }

    public formData: any = {
        code: '',
        carrierId: '',
        primaryDeptName: '',
        carrierName: '',
        validityStartTime: '',
        validityEndTime: '',
        amount: '',
        signTime: '',
        inquiryId: '',
        inquiryCode: '',
        addAttachment: {
            id: '',
            attachmentName: '',
            attachmentPath: '',
            attachmentDataId: '',
            attachmentTag: '',
            attachmentTable: '',
        },
    };
    drivingLicenseImgs: any = [];
    roadTransportCertificateImgs: any = [];
    businessLicenseImgs: any = [];

    public title = '新增合同';

    public save() {
        try {
            let nn = (this.formData.amount + '').split('.')[1];
            if (nn.length > 2) {
                this.formData.amount = Number((this.formData.amount + '').split('.')[0] + '.' + nn.slice(0, 2));
            }
        } catch (e) {}
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                if (this.title == '新增合同') {
                    let res = await yun.ContractAdd(this.formData);
                    this.$alert('添加成功');
                    this.dialogVisible = false;
                    this.loadData();
                } else {
                    let res = await yun.CarUpdate(this.formData);
                    this.$alert('编辑成功');
                    this.loadData();
                    this.dialogVisible = false;
                }
            }
        });
    }

    public async toEdit(data) {
        this.title = '合同详情';
        this.drivingLicenseImgs = [];
        this.roadTransportCertificateImgs = [];
        this.businessLicenseImgs = [];
        this.formData = {
            primaryDeptName: '',
            code: '',
            carrierId: '',
            carrierName: '',
            validityStartTime: '',
            validityEndTime: '',
            amount: '',
            signTime: '',
            inquiryId: '',
            inquiryCode: '',
            addAttachment: {
                id: '',
                attachmentName: '',
                attachmentPath: '',
                attachmentDataId: '',
                attachmentTag: '',
                attachmentTable: '',
            },
        };
        this.fileList = [];

        if (data.attachment.attachmentPath) {
        // console.log(data.attachment.attachmentPath.substring(data.attachment.attachmentPath.lastIndexOf('.')+1))
        //  if(data.attachment.attachmentPath.substring(data.attachment.attachmentPath.lastIndexOf('.')+1) === 'xlsx' || 'xls' || 'doc'){
            if(data.attachment.attachmentPath.includes('xlsx') || data.attachment.attachmentPath.includes('xls')||data.attachment.attachmentPath.includes('doc')){
             let newurl = 'https://view.officeapps.live.com/op/view.aspx?src='+ data.attachment.attachmentPath
             window.open(newurl,'_blank')
           }
           else {
            window.open(data.attachment.attachmentPath)
            
           }
            this.fileList.push({
                name: data.attachment.attachmentName,
                url: data.attachment.attachmentPath,
            });
        }
        this.timeList1 = [data.validityStartTime, data.validityEndTime];
        Object.keys(data).forEach((key) => {
            this.formData[key] = data[key];
        });
        this.formData.addAttachment = data.attachment;
        try {
            // this.$refs.formData.resetFields();
        } catch (e) {}
        // this.dialogVisible1 = true;
    }
    public dialogConfig: any = {
        title: '终结该运单',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    async confirmOk() {
        if (this.btt == 3) {
            yun.ContractDelete(this.ssid).then(() => {
                this.$message.success('删除成功');
                this.loadData();
            });
        }
        this.dialogConfig = {
            show: false,
        };
    }
    public btt: any = 0;
    public ssid: any = '';
    public toDel(id) {
        this.ssid = '';
        this.ssid = id;
        this.btt = 3;
        this.dialogConfig = {
            title: '删除合同',
            show: true,
        };
        // this.$confirm('确认删除该合同?', '删除合同', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         yun.ContractDelete(id).then(() => {
        //             this.$message.success('删除成功');
        //             this.loadData();
        //         });
        //     })
        //     .catch(() => {});
    }

    /** 新增 */
    public selectedId: any = '';
    public selectionRow = [] as any;

    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    public carTypeChange(item) {
        //this.form.platformCompanyId = item.code
        console.log('item', item);
        this.vehicleTypeList.forEach((data) => {
            if (data.value == item) this.formData.carType = data.name;
        });
    }
    public carLengths = [];
    public carLengthChange(item) {
        //this.form.platformCompanyId = item.code
        this.searchValue.carLength = '';
        this.carLengths.forEach((data, index) => {
            if (index > 0) {
                this.searchValue.carLength = this.searchValue.carLength + ',' + data;
            } else {
                this.searchValue.carLength = data;
            }
        });
        this.carLengthList.forEach((data) => {
            if (data.value == item) this.formData.carLength = data.name;
        });
    }
    fileList: any = [];
    showViewer: any = false;
    closeViewer() {
        this.showViewer = false;
    }
    public handleRemove(file, fileList) {
        this.fileList = fileList;
        this.formData.addAttachment.attachmentName = '';
        this.formData.addAttachment.attachmentPath = '';
    }

    public handlePreview(file, name) {
        console.log(file);
    }

    public isload: any = 0;
    public loadcc: any = 0;
    flexColumnWidth(str, tableData, flag = 'max') {
        console.log('tableData', tableData);
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return '150px';
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            let index = 0;
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str] === null) {
                    return;
                }
                const now_temp = tableData[i][str] + '';
                const max_temp = tableData[index][str] + '';
                if (now_temp.length > max_temp.length) {
                    index = i;
                }
            }
            columnContent = tableData[index][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (str == 'consigneePhone') {
            flexWidth = flexWidth * 2;
        }
        if (flexWidth < 120) {
            // 设置最小宽度
            flexWidth = 120;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
    public async handleChange(file, fileList) {
        if (this.fileList.length == 1) {
            this.$message.warning('最多上传1个附件!');
            return;
        }
        var theFile = file.raw;
        //实例化一个文件读取器
        var fileReader = new FileReader();
        //将用户上传的文件对象作为参数，传入文件读取器的方法readAsDataURL
        fileReader.readAsDataURL(theFile);
        let that = this;
        fileReader.onload = function () {};
        let size = theFile.size / 1024;
        console.log(theFile);

        if (!publicFunc.isFile(file.name)) {
            this.$message.error('请上传规定格式文件');
            return;
        }
        if (size > 51200) {
            this.$message.error('文件大小超过50M');
            return;
        }
        this.isload = 1;
        this.loadcc = 0;
        let timego: any = setInterval((_) => {
            if (this.loadcc > 99) {
                this.isload = 2;
                clearInterval(timego);
            } else {
                if (this.loadcc < 80 || this.loadcc > 85) {
                    this.loadcc = this.loadcc + 1;
                }
            }
        }, 100);
        const res = await upload(theFile, file.name);
        this.loadcc = 90;
        setTimeout((_) => {
            this.isload = 0;
        }, 1500);

        var imageUrl = res.res.requestUrls[0].split('?')[0];
        this.formData.addAttachment.attachmentName = file.name;
        this.formData.addAttachment.attachmentPath = imageUrl;
        this.fileList.push({ name: file.name, url: imageUrl });
    }

    removeImage(index) {
        this.fileList.splice(index, 1);
        this.formData.addAttachment.attachmentName = '';
        this.formData.addAttachment.attachmentPath = '';
    }
    cc;
    store;

    async updateImage(e: any) {
        let param = new FormData();
        const file = e.file;
        param.append('excel', file);
        let res = await yun.DriverImportCars(param);
        if (res) {
            this.$emit('updateSearch');
            this.$message.success('导入成功!');
        } else {
            this.$message.error('导入失败!');
        }
    }
    public selectDirver: any = {};
    async dirverCars(data) {
        this.selectDirver.id = data.id;
        this.searchPagin1.skip = 0;
        this.dialogVisibles = true;
        this.carName = '';
        this.loadData1();
    }
    public carName = '';
    carid;
    selectCar(data) {
        console.log(data);
        this.carid = data.id;
    }
    public async dirverbind() {
        let res = await yun.DriverBind({ CarrierCarId: this.selectDirver.id, CarrierDriverId: this.carid });
        this.$alert('绑定成功');
        this.loadData1();
    }
    async querySearch(queryString, cb) {
        let res = await yun.GetDriverList({ carCode: this.carName });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        cb(result);
    }
    public carrierName = '';
    selectList = [];
    selectCar1(data) {
        this.searchValue.carrierId = data.id;
    }
    selectCar2(data) {
        this.formData.carrierId = data.id;
    }
    async querySearch1(queryString, cb) {
        this.searchValue.carrierId = '';
        let res = await yun.GetCarrierList({ Name: this.carrierName, count: -1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    public carrierName1: any = '';
    public carCodeEnd() {
        console.log('cc2');
        if (!this.formData.carrierId) {
            this.formData.carrierName = '';
        }
    }
    public carCodechange(val) {
        this.formData.carrierId = '';
    }
    async querySearch2(queryString, cb) {
        let res = await yun.GetCarrierList({ Name: this.formData.carrierName, count: -1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'signTime':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = 2;
                }
                break;
        }
        this.loadData();
    }
    public async exportExcel() {
        let res = await yun.CarExport({ ...this.searchValue });
    }
    public addNew() {
        this.title = '新增合同';
        this.formData = {
            code: '',
            primaryDeptName: '',
            carrierId: '',
            carrierName: '',
            validityStartTime: '',
            validityEndTime: '',
            amount: '',
            signTime: '',
            inquiryId: '',
            inquiryCode: '',
            addAttachment: {
                id: '',
                attachmentName: '',
                attachmentPath: '',
                attachmentDataId: '',
                attachmentTag: '',
                attachmentTable: '',
            },
        };
        this.fileList = [];
        this.timeList1 = [];
        try {
            this.$refs.formData.resetFields();
        } catch (e) {}
        this.dialogVisible = true;
    }
    download(href, filename) {
        window.open(href);
        // const a = document.createElement('a');
        // a.download = filename;
        // a.href = href;
        // document.body.appendChild(a);
        // a.click();
        // a.remove();
    }
    viewFile(item) {
        window.open(item.url);
    }
}
